<template>
    <component
        :is="computedAsset?.component"
        v-if="computedAsset"
        v-bind="computedAsset?.asset"
        @click="$emit('click')"
    />
</template>
<script setup>
import { computed, useAttrs } from 'vue';
import { resolveComponent } from '#imports';

const attrs = useAttrs();
const props = defineProps({
    asset: {
        type: [Array, Object],
        required: false,
        default: () => ({}),
    },
});
defineEmits(['click']);

const computedAsset = computed(() => {
    if (!props.asset) return false;
    let { asset } = props;

    if (props.asset[0]) {
        asset = Object.assign(props.asset[0], attrs);
    } else asset = Object.assign(props.asset, attrs);
    const ext = asset.ext?.toLowerCase();

    if ([
        'jpeg',
        'jpg',
        'gif',
        'png',
        'webp',
        'pdf',
    ].includes(ext)) {
        return { component: resolveComponent('DSFrontifyImage'), asset };
    } else if ([
        'svg',
    ].includes(ext)) {
        asset.size = asset.iconsize;

        return { component: resolveComponent('DSFrontifyVector'), asset };
    } else if ([
        'mp4',
        'webm',
    ].includes(ext)) {
        asset.autoplay = true;

        return { component: resolveComponent('DSFrontifyVideo'), asset };
    }

    return null;
});
</script>
